import React from "react";
import { useField } from "formik";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import PropTypes from "prop-types";

const CustomDataPicker = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);

  const handleChange = date => {
    helpers.setValue(date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        {...field}
        {...props}
        label={label}
        format="dd-MM-yyyy"
        value={field.value || null}
        error={meta.touched && meta.error}
        onChange={handleChange}
        onBlur={() => helpers.setTouched(true)}
      />
    </MuiPickersUtilsProvider>
  );
};

CustomDataPicker.propTypes = {
  label: PropTypes.string,
  valueRadio: PropTypes.string,
  error: PropTypes.any
};
export default CustomDataPicker;
